import styled from 'styled-components';
import { TextAreaInput } from '@cfa/react-core';

export const MultilineTextInput = styled(TextAreaInput)`
  & textarea {
    resize: none;
  }
`;
